import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { GoogleOAuthProvider, GoogleLogin, googleLogout } from '@react-oauth/google';
import { USER_LOGIN } from '../../store/actions';
import { Card, Alert, AlertTitle, Dialog, Button } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadTwoButtonTable from '../components/StickyHeadTwoButtonTable';
import axios from "../../components/axios";
import { useLocation } from 'react-router-dom';
import PieChartNoTable from '../components/Chart/PieChartNoTable';

const TestAutoSharePage = () => {
  const client_id = process.env.REACT_APP_CLIENT_ID;
  var user_login = useSelector(state => state.customization.login);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(true);
  const [showAlert, setshowAlert] = useState(false);
  const [noDataMessage, setNoDataMessage] = useState('');
  const threshold = 1000;
  const exportURL = '/peloton/v1/automation/filter-test-csv';
  const [fullQuery, setFullQuery] = useState('');
  const [openSummary, setOpenSummary] = useState(false);
  const [series, setSeries] = useState([]);
  const [total, setTotal] = useState(0);
  const [pass, setPass] = useState(0);
  const [fail, setFail] = useState(0);
  const [skip, setSkip] = useState(0);
  const showShare = false;
  const showSummary = true;

const styleButton = {
        width: "120px",
        fontSize: "16px",
        fontFamily: '"Roboto", "sans-serif"',
    };

  const columns = [
    { id: 'serial_number', label: 'Serial Number', align: 'left' },
    { id: 'affernet', align: 'center', label: 'Affernet'},
    { id: 'dm', align: 'center', label: 'DM'},
    { id: 'start_time', align: 'center', label: 'Start Time'},
    { id: 'end_time', align: 'center', label: 'End Time'},
    { id: 'OTA_service', align: 'center', label: 'OTA service'},
    { id: 'fw_updater', align: 'center', label: 'FW Updater'},
    { id: 'home_app', align: 'center', label: 'Home App'},
    { id: 'platform', align: 'center', label: 'platform'},
    { id: 'suite_name', align: 'center', label: 'Suite Name'},
    { id: 'system_image', align: 'center', label: 'System Image'},
    { id: 'system_image_type', align: 'center', label: 'Image Type'},
    { id: 'total', align: 'center', label: 'Total'},
    { id: 'pass', align: 'center', label: 'Pass'},
    { id: 'fail', align: 'center', label: 'Fail'},
    { id: 'skip', align: 'center', label: 'Skip'},
    { id: 'action', label: 'Download', align: 'center', action: true},
    { id: 'view', label: 'Show', align: 'center', view: true },
  ];

  const handleSummary = () => {
    setOpenSummary(true)
  };

  const useQueryParams = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQueryParams();

  const handleQueryData = useCallback(() => {
        setTotal(0);
        setPass(0);
        setFail(0);
        setSkip(0);
        setSeries([]);
        setRows([]);
        var input_data = JSON.stringify({ query: query.get("query")})
        setFullQuery(input_data);
        axios.post("/peloton/v1/automation/share-report",input_data,{withCredentials: true})
        .then(response => {
          if (response.data.message === "success") {
            dispatch({ type: USER_LOGIN, login: true });
            if (response.data.data !== null && response.data.data.length > 0){
              if (response.data.data.length >threshold){
                  setshowAlert(true);
                  setNoDataMessage('More than 1000 rows, please click "Export Data" to download file')
              }else{
                setRows(response.data.data);
                setshowAlert(false);
              }
              setTotal(response.data.total_count);
              setPass(response.data.pass_count);
              setFail(response.data.fail_count);
              setSkip(response.data.skip_count);
              setSeries([response.data.pass_count, response.data.fail_count, response.data.skip_count]);
              setshowTable(true);
            }else{
              setNoDataMessage('No data in this condition.')
              setshowAlert(true);
            }
          }else{
            alert(response.data.message);
          }
        }).catch(error => {
          if (error.message === 'timeout of 3000ms exceeded'){
            setshowAlert(true);
            setNoDataMessage('Too many rows, please click "Export Data" to download file')
            setshowTable(true);
          }else{
            if (!error.response){
              alert(error)
            }else{
              if (error.response.status === 401){
                dispatch({ type: USER_LOGIN, login: false });
              }else{
                alert(error.response.data.message);
              }
            }
          }
        })
    }, [dispatch, query]);

    const handleLogout = useCallback(() => {
        googleLogout();
        axios.post("/peloton/v1/users/logout", null, { withCredentials: true});
        alert("Logout success!");
        localStorage.removeItem("gapi.tokenId");
        localStorage.removeItem("qbarn.user");
        dispatch({ type: USER_LOGIN, login: false });
    }, [dispatch]);

  useEffect(() => {
    const checkUserToken = async () => {
            try {
                const response = await axios.post("/peloton/v1/users/auth-token", null, { withCredentials: true});
                if (response.data.message === "success"){
                    dispatch({ type: USER_LOGIN, login: true });
                    handleQueryData();
                }
            } catch (error) {
                handleLogout();
                if (error.response.status !== null){
                    console.log('error.response.status: ', error.response.status);
                    console.log('error.response.message: ', error.response.data.message);
                }else{
                    console.log(error);
                }
            }
        };
        if (localStorage.getItem( "qbarn.user" ) !== null) {
            checkUserToken();
        }else{
            dispatch({ type: USER_LOGIN, login: false });
        }
  }, [dispatch, handleQueryData, handleLogout]);

  const handleClose = () => {
    setOpenSummary(false);
  };

  const handleDownload = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid })
      axios.post("/peloton/v1/automation/test-report-file", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(response.data.url, "_blank");
        }else{
            alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            dispatch({ type: USER_LOGIN, login: false });
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleRedirect = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid });
      axios.post("/peloton/v1/automation/test-report-pages", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(process.env.REACT_APP_API_URL+response.data.url, "_blank");
        }else{
          alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            dispatch({ type: USER_LOGIN, login: false });
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  function getPermission() {
        let idToken = localStorage.getItem( "gapi.tokenId" )
        axios.post("/peloton/v1/users/role-permission",null,{
            headers: {
              'Authorization': 'Bearer '+idToken
            },
            withCredentials: true
        })
        .then(response => {
            if (response.data.message === "success") {
                if (localStorage.getItem( "qbarn.user" ) === null && response.data.user_info !== undefined) {
                    localStorage.setItem("qbarn.user", JSON.stringify(response.data.user_info))
                    handleQueryData();
                }
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
              if (err.response.status === 401){
                  dispatch({ type: USER_LOGIN, login: false });
              }else{
                  console.log('error.response.status: ', err.response.status)
                  console.log('error.response.status: ', err.response.data.message)
                  alert(err.response.data.message)
              }
            }
        })
    };

  const responseGoogle = (response) => {
    dispatch({ type: USER_LOGIN, login: true });
    localStorage.setItem("gapi.tokenId",response.credential);
    getPermission();
  };

  return (
    <MainCard>
    <Dialog open={openSummary} onClose={handleClose} fullWidth>
        <PieChartNoTable series={series} total={total} pass={pass} fail={fail} skip={skip}/>
      </Dialog>
      {!user_login && (
                <GoogleOAuthProvider clientId={client_id}>
                    <GoogleLogin
                        onSuccess={responseGoogle}
                        onError={responseGoogle}
                        text='Login'
                        useOneTap
                  /></GoogleOAuthProvider>)}
      {user_login && (<Button style={styleButton} onClick={handleLogout}>Logout</Button>)}
      { user_login && showTable && (<StickyHeadTwoButtonTable rows={rows} columns={columns} handleDownload={handleDownload} handleRedirect={handleRedirect} exportURL={exportURL} fullQuery={fullQuery} showSummary={showSummary} handleSummary={handleSummary} showShare={showShare}/>)}
      { user_login && showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {noDataMessage}
      </Alert></Card>)}
    </MainCard>)
};

export default TestAutoSharePage;
